/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import classnames from 'classnames';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';

import Modal from 'components/modal';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import { getUserAccountNameById } from 'helpers/utils';
import { useLockedBody } from 'hooks';
import {
  CrossIcon,
  MobileModalCloseIconNew,
  SelectedTag,
  TickIcon,
} from 'styles/assets/icons';
import IUser, { IUserKernel } from 'types/IUser';
import { KycConfirmButton, KycCancelButton, Button } from 'UIKit';

import styles from './switchSubAccountModal.module.scss';

interface SwitchSubAccountModalProps {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  subAccounts: IUserKernel[];
  user: IUser;
  switchAccount: (userId: number) => void;
  switchToMainAcc: () => void;
}

const SwitchSubAccountModal = ({
  isModalOpen,
  handleCloseModal,
  subAccounts,
  switchAccount,
  switchToMainAcc,
  user,
}: SwitchSubAccountModalProps) => {
  const { t } = useTranslation(['account', 'common']);

  const [selectedUser, setSelectedUser] = useState<IUser | IUserKernel>(user);
  const [isMainActivated, setIsMainActivated] = useState(false);

  useLockedBody(isModalOpen);

  useEffect(() => {
    setIsMainActivated(user.main_account ? user.main_account.id === user.id : true);
  }, [user.id]);

  const submit = () => {
    if (selectedUser.id !== user.id) {
      const sourceAccount = getUserAccountNameById(user.id, user);
      const destinationAccount = getUserAccountNameById(selectedUser.id, selectedUser);
      trackMixpanelEvent('Account Switched - All Pages - Subaccounts', {
        source: 'sub-accounts page',
        source_account_name: sourceAccount,
        destination_account_name: destinationAccount,
      });

      selectedUser.is_sub_account ? switchAccount(selectedUser.id!) : switchToMainAcc();
      handleCloseModal();
    }
  };

  const onCloseModal = () => {
    handleCloseModal();
  };

  useEffect(() => {
    if (!isModalOpen) {
      setSelectedUser(user);
      setIsMainActivated(user.main_account ? user.main_account.id === user.id : true);
    }
  }, [isModalOpen, user]);
  return (
    (<Modal
      className={classnames({
        'full-common-modal': !!isMobile,
        'common-modal-content': !isMobile,
      })}
      classOverlayName={classnames({
        'common-modal-overlay': !!isMobile,
        'switch-account-modal': isMobile,
      })}
      isOpen={isModalOpen}
      onRequestClose={onCloseModal}
      contentLabel={t('account:subAccount.editSubAccount')}
    >
      <div className={styles[`switch-sub-account-modal`]}>
        <div className={styles.heading}>
          <div />
          <div className={styles.switchAccountHeading}>
            {t('account:subAccount.switchSubAccounts')}
          </div>
          <div
            aria-hidden="true"
            className={styles.closeIcon}
            data-testid="subAccountModalCloseButton"
            onClick={onCloseModal}
          >
            <MobileModalCloseIconNew fillColor="var(--main-text-primary)" />
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.content}>
            <div
              data-testid="Yfq1CPgle17jjB1BCLqWw"
              aria-hidden="true"
              className={classnames(styles.item, {
                [styles.selectedItem]: !user.is_sub_account,
                [styles.tickItem]: selectedUser.id === user?.main_account?.id,
              })}
              onClick={() => {
                setSelectedUser(user.main_account || user);
                // setIsMainActivated(true);
              }}
            >
              <label
                className={classnames({
                  active: !!isMainActivated,
                })}
              >
                Main Account
              </label>
              {!user.is_sub_account && (
                <SelectedTag className={styles['main-account-in-use-icon']} />
              )}
              {selectedUser.id === user?.main_account?.id && (
                <TickIcon className={styles['active-icon']} />
              )}
            </div>
            {/* <div className={styles.title}>
              <label>{t('account:subAccount.subAcccounts')}</label>
            </div> */}
            {subAccounts.map((account, index) => {
              return (
                (<div
                  data-testid="Hm8c9xH6oYTAMeJPKLHPI"
                  aria-hidden="true"
                  className={classnames('truncate', styles.item, {
                    [styles.selectedItem]: user.id === account.id,
                    [styles.tickItem]:
                      selectedUser.id === account.id && user.id !== account.id,
                  })}
                  key={account.id}
                  onClick={() => {
                    setSelectedUser(account);
                    setIsMainActivated(false);
                  }}
                  data-palette="SwitchSubAccountModal">
                  <label
                    className={classnames({
                      active: selectedUser.id === account.id,
                    })}
                  >
                    {account.account_name}
                  </label>
                  {selectedUser.id === account.id && user.id !== account.id && (
                    <div className={styles.tickIcon} data-palette="SwitchSubAccountModal">
                      <TickIcon className={styles['active-icon']} />
                    </div>
                  )}
                  {user.id === account.id && (
                    <SelectedTag className={styles['sub-account-in-use-icon']} />
                  )}
                </div>)
              );
            })}
          </div>
          <div className={styles.footer}>
            <MediaQuery query={device.up.md}>
              <div className={styles[`buttons-container`]}>
                <KycConfirmButton
                  data-testid="N7LV_9TLTpzy3kq5nmIpd"
                  className={styles[`modal-button`]}
                  onClick={submit}
                >
                  {t('account:confirm')}
                </KycConfirmButton>
              </div>
            </MediaQuery>
            <MediaQuery query={device.down.md}>
              <Button
                data-testid="FLUAuvdrbJffvI0cS_fj1"
                className={styles[`confirm-button-mobile`]}
                onClick={submit}
              >
                {t('account:confirm')}
              </Button>
            </MediaQuery>
          </div>
        </div>
      </div>
    </Modal>)
  );
};
export default SwitchSubAccountModal;
